import { Link } from "react-router-dom";

export function Logo({ to = "/", small }) {
  return (
    <Link to={to} className="flex items-center gap-2.5 group" data-testid="logo-link">
      <span className="relative grid place-items-center w-8 h-8 rounded-lg bg-[#0A0D14] border border-blue-500/40 shadow-[0_0_18px_rgba(59,130,246,0.35)]">
        <svg viewBox="0 0 24 24" className="w-4.5 h-4.5" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="6" cy="6" r="2.2" className="text-cyan-400" stroke="#22d3ee" />
          <circle cx="18" cy="8" r="2.2" stroke="#3b82f6" />
          <circle cx="10" cy="18" r="2.2" stroke="#10b981" />
          <path d="M8 7l8 1M7 8l2.5 8M12 17l5-7" stroke="#64748b" />
        </svg>
      </span>
      {!small && (
        <span className="font-display font-bold tracking-[0.18em] text-white text-sm group-hover:text-cyan-300 transition-colors">
          SYNAPSIS
        </span>
      )}
    </Link>
  );
}
